import { render } from "./DateRangePicker.vue?vue&type=template&id=56d60f2b&ts=true"
import script from "./DateRangePicker.vue?vue&type=script&lang=ts"
export * from "./DateRangePicker.vue?vue&type=script&lang=ts"

import "./DateRangePicker.vue?vue&type=style&index=0&id=56d60f2b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__